import config from 'constants/config'
import { isLuxLoyaltyEnabledInAgentHub } from 'agentHub/selectors/isLuxLoyaltyEnabledInAgentHub'
/**
 * Whether the Société / Lux Loyalty program is enabled.
 *
 * Gated purely by config:
 * - Customer brands: enabled when the brand sets `LUX_LOYALTY_ENABLED` (only the
 *   Luxury Escapes brand does). Available in every region. This replaces the
 *   removed `lux_loyalty_feature_toggle` Optimizely gate.
 * - Agent Hub: enabled via `isLuxLoyaltyEnabledInAgentHub` (`LUX_LOYALTY_ENABLED`)
 *   so agents can apply a traveller Société number on the sale. Agent self-earn
 *   is a separate flag (`LUX_LOYALTY_IN_AGENT_HUB`).
 *
 * The `_state` argument is retained so this keeps the shape of a Redux selector
 * (used directly and via `useAppSelector`), even though enablement no longer
 * depends on any redux state.
 */
function getIsLoyaltyEnabled(_state?: App.State): boolean {
  if (!config.LUX_LOYALTY_ENABLED) {
    return false
  }

  if (config.agentHub?.isEnabled) {
    return isLuxLoyaltyEnabledInAgentHub
  }

  return true
}

export default getIsLoyaltyEnabled
